var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid",attrs:{"data-qa":_vm.dataQa}},[_c('TooltipedText',{attrs:{"data-qa":_vm.dataQa + '-title',"line-count":1,"value":_vm.title}}),(_vm.description)?_c('TooltipedText',{staticClass:"opacity-6 mt-2",attrs:{"data-qa":_vm.dataQa + '-description',"line-count":1,"line-height":1.5,"value":_vm.description}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }